// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .title-label {
  padding-left: 16px;
  font-size: 1.6rem;
  font-weight: bold;
  color: #999;
}
:host .venue-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}
:host .venue-location {
  font-size: 12px;
  color: #999;
}
:host .clear-button {
  text-align: right;
  margin-top: 0;
  margin-right: 10px;
  -webkit-text-decoration: underline #999;
          text-decoration: underline #999;
  color: #999;
}
:host .venue-list {
  margin-bottom: 0;
}
:host .location-help-icon {
  font-size: 1.6rem;
  margin-left: 5px;
  color: #999;
}
:host .bold {
  font-weight: bold;
}
:host .close-icon {
  color: #999;
  font-size: 2rem;
}
:host .close-icon-div {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translate(0, -50%);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
